import type { InputHTMLAttributes, ReactNode } from 'react';
import { FormMessage } from './FormMessage';
import { useFieldA11y } from './fieldA11y';

interface CheckboxFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'aria-invalid' | 'type'> {
  label: ReactNode;
  helperText?: string;
  error?: string;
  containerClassName?: string;
}

export const CheckboxField = ({
  id,
  label,
  helperText,
  error,
  className,
  containerClassName,
  ...inputProps
}: CheckboxFieldProps) => {
  const { fieldId, helperId, errorId, describedByIds } = useFieldA11y({
    id,
    describedBy: inputProps['aria-describedby'],
    helperText,
    error,
  });

  return (
    <div
      className={[
        'form-choice',
        error ? 'form-choice--invalid' : '',
        containerClassName,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <label className="form-choice__control" htmlFor={fieldId}>
        <input
          id={fieldId}
          type="checkbox"
          aria-invalid={error ? true : undefined}
          aria-describedby={describedByIds}
          {...inputProps}
        />
        <span>{label}</span>
      </label>
      <FormMessage id={helperId}>{helperText}</FormMessage>
      <FormMessage id={errorId} tone="error">
        {error}
      </FormMessage>
    </div>
  );
};
